var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"settings-item ellipsis",class:[
    _vm.active ? 'active' : '',
    _vm.header ? 'header' : '',
    _vm.customButton ? 'no-hover' : '',
  ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.header)?_c('SaIcon',{attrs:{"name":"angle-left"}}):_c('SaIcon',{attrs:{"name":_vm.icon}}),_vm._v(" "),(!_vm.customButton)?_c('span',{staticClass:"ellipsis"},[(_vm.header)?_c('SaIcon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2):_vm._t("default"),_vm._v(" "),(_vm.openButton)?_c('SaIcon',{attrs:{"name":"angle-right"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }